// Historial de dispensaciones (2026-09-11) — trazabilidad propia del
// Director Técnico, sin necesitar el panel CRM. "Dispensación" ahora es
// cualquier línea de una orden VENDIDA que vino de una receta de la cola
// (`medicationRequestRef`, ver OrdenesFarmacia.tsx) — antes se leía por un
// prefijo de `reason` en stock_moves, puesto por el ya retirado
// `venderDispensacionFarmacia` (Vender es hoy el único camino de venta, así
// que la señal correcta es la línea de la orden, no el movimiento de stock).
import type { JSX } from 'react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { listarOrdenesFarmacia, type OrdenFarmacia } from '@/lib/farmaciaInterna';

export function HistorialFarmacia(): JSX.Element {
  const { t } = useTranslation();
  const [ordenes, setOrdenes] = useState<OrdenFarmacia[]>();

  useEffect(() => {
    listarOrdenesFarmacia().then((r) => setOrdenes(r.orders));
  }, []);

  if (ordenes === undefined) return <p className="text-sm text-hce-muted">{t('farmaciaApp.cargando')}</p>;

  const dispensaciones = ordenes
    .filter((o) => o.status === 'invoiced')
    .flatMap((o) => o.lines.filter((l) => l.medicationRequestRef).map((l) => ({ orden: o, linea: l })));

  if (dispensaciones.length === 0) return <p className="text-sm text-hce-muted">{t('farmaciaApp.historial.vacio')}</p>;

  return (
    <div className="divide-y divide-border rounded-lg border border-border">
      {dispensaciones.map(({ orden, linea }) => (
        <div key={linea.id} className="flex items-center justify-between gap-3 px-3 py-2.5 text-sm">
          <span className="min-w-0 flex-1">
            <span className="block truncate text-hce-ink">{linea.description}</span>
            <span className="block text-xs text-hce-muted">
              {t('farmaciaApp.historial.cantidad', { cantidad: linea.quantity })} · #{orden.id}
            </span>
          </span>
          <span className="shrink-0 text-xs text-hce-muted">{new Date(orden.createdAt).toLocaleString('es-EC')}</span>
        </div>
      ))}
    </div>
  );
}
